export default  {
	formatNumber: (number) => {
			if (number === undefined || number === '' ) {
					number = 0;
			}

			return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
	},

	capitalize: (text) => {
			if (typeof(text) !== 'string' || !text.length) {
					return '';
			} else {
					return text.charAt(0).toUpperCase() + text.slice(1);
			}
	},

	validateEmail: (email) => {
			if(typeof(email) !== 'string' || !email.length) {
					return false;
			} else {
					/* const validator = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i; */
					const validator = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
					const response = validator.test(email);
					
					return response;
			}
	},

	booleanToNum: (booleano) => {
		let resultado = booleano ? 1 : 0; 
		return resultado; 
	},

	toBoolean: (dato) => {
		let resultado = dato==="1" ? true : false;
		return resultado
	}, 

	unEspacio: (string) => {
		string = string.replace(/  +/g, ' ');
		string = string.trim(); 
		return string; 
	},

	espacioGuion: (string) =>{
		string = string.replace(/  +/g, ' ');
		string = string.trim();
		string = string.replace(/\s/g, "_");
		return string;
	},

	simpleEncode: (str, pwd) =>{
		if(str==="")return "";
		str = escape(str);
		if(!pwd || pwd===""){ pwd="a32sd3as1dasd3666"; }
		pwd = escape(pwd);
		let prand = "";
		for(let I=0; I<pwd.length; I++) {
		  prand += pwd.charCodeAt(I).toString();
		}
		let sPos = Math.floor(prand.length / 5);
		let mult = parseInt(prand.charAt(sPos) + prand.charAt(sPos*2) + prand.charAt(sPos*3) + prand.charAt(sPos*4) + prand.charAt(sPos*5));
		let incr = Math.ceil(pwd.length / 2);
		let modu = Math.pow(2, 31) - 1;
		let salt = Math.round(Math.random() * 1000000000) % 100000000;
	  
		prand += salt;
	  
		while(prand.length > 10) {
		  prand = (parseInt(prand.substring(0, 10)) + parseInt(prand.substring(10, prand.length))).toString();
		}
	  
		prand = (mult * prand + incr) % modu;
	  
		let enc_chr = "";
		let enc_str = "";
	  
		for(let I=0; I<2; I++) {
		  enc_chr = parseInt(str.charCodeAt(I) ^ Math.floor((prand / modu) * 255));
		  if(enc_chr <16) {
			enc_str += "0" + enc_chr.toString(16);
		  }else
		  enc_str += enc_chr.toString(16);
		  prand = (mult * prand + incr) % modu;
		}
		salt = salt.toString(16);
		while(salt.length <8)salt = "0" + salt;
		enc_str += salt;
		return enc_str;
	}, 

	validaRut : (string) =>{
	
		if (!/^0*(\d{1,3}(\.?\d{3})*)-?([\dkK])$/.test(string)) {
			return false
		}

		let rut = string.replace(/^0+|[^0-9kK]+/g, '').toUpperCase(); 

		let t = parseInt(rut.slice(0, -1), 10)
		let m = 0
		let s = 1
	  
		while (t > 0) {
		  s = (s + (t % 10) * (9 - m++ % 6)) % 11
		  t = Math.floor(t / 10)
		}
	  
		let v = s > 0 ? '' + (s - 1) : 'K'
		return v === rut.slice(-1)

	},

	generarPass : (largo) => {
		let long = parseInt(largo);
		let caracteres = "abcdefghijkmnpqrtuvwxyzABCDEFGHIJKLMNPQRTUVWXYZ2346789";
		let pass = "";
		for (let i=0; i<long; i++) pass += caracteres.charAt(Math.floor(Math.random()*caracteres.length));
		return pass;
	}
};